
import { saveAs } from 'file-saver';
import { Injectable } from '@angular/core';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
 
 

@Injectable({
  providedIn: 'root'
})
export class ExcelExportService {
  exportGrid(e: any) {
         const workbook = new Workbook();
     const worksheet = workbook.addWorksheet('Employees');

     exportDataGrid({
         component: e.component,
         worksheet: worksheet
     }).then(function () {
         workbook.xlsx.writeBuffer().then(function (buffer) {
             saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
         });
     });
    
  }
}


